import { useEffect } from "react";
import {
  ensureVideoPictureInPictureDisabled,
  patchVideoElementsInSubtree,
} from "@/utils/videoPictureInPicturePolicy";

/**
 * Verhindert Picture-in-Picture für alle App-Videos (auch dynamisch gemountet).
 * Eine zentrale Stelle statt dutzende video-Tags manuell anzufassen.
 */
export function useGlobalDisablePictureInPicture(): void {
  useEffect(() => {
    if (typeof document === "undefined") return;

    patchVideoElementsInSubtree(document);

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const added of mutation.addedNodes) {
          if (added instanceof HTMLVideoElement) {
            ensureVideoPictureInPictureDisabled(added);
          } else if (added instanceof Element) {
            patchVideoElementsInSubtree(added);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);
}
